import { motion } from "framer-motion";
import { useLenisReduced } from "../../lib/motionFlag";

export default function LoadingScreen({ message, error, onRetry }) {
  const reduced = useLenisReduced();

  return (
    <div
      data-testid="site-loading"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-white px-6"
    >
      <div className="flex flex-col items-center">
        {/* Approved ADMALL INDIA Logo */}
        <img
          src="/admall-logo.png"
          alt="ADMALL INDIA"
          className="h-12 w-auto object-contain sm:h-16"
        />

        {error ? (
          <div className="mt-6 flex flex-col items-center gap-3">
            <p className="font-body text-xs text-red-500">{error}</p>
            {onRetry && (
              <button
                onClick={onRetry}
                className="rounded-full bg-[#FF5722] px-5 py-2 font-display text-xs font-bold uppercase tracking-wider text-white hover:bg-[#E64A19] transition"
              >
                Retry
              </button>
            )}
          </div>
        ) : (
          /* Minimal Elegant Indicator */
          <div className="mt-8 h-0.5 w-32 overflow-hidden rounded-full bg-black/5 sm:w-40">
            {reduced ? (
              <div className="h-full w-full bg-[#FF5722]" />
            ) : (
              <motion.div
                className="h-full w-1/3 rounded-full bg-[#FF5722]"
                animate={{
                  x: ["-100%", "300%"],
                }}
                transition={{
                  repeat: Infinity,
                  duration: 1.2,
                  ease: "easeInOut",
                }}
              />
            )}
          </div>
        )}

        {message && !error && (
          <p className="mt-4 font-body text-xs text-navy/50 tracking-wider">
            {message}
          </p>
        )}
      </div>
    </div>
  );
}
